/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */
import '@angular/localize/init';

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/features/array';
import 'core-js/features/date';
import 'core-js/features/function';
import 'core-js/features/map';
import 'core-js/features/math';
import 'core-js/features/number';
import 'core-js/features/object';
import 'core-js/features/parse-float';
import 'core-js/features/parse-int';
import 'core-js/features/reflect';
import 'core-js/features/regexp';
import 'core-js/features/set';
import 'core-js/features/string';
import 'core-js/features/symbol';
import 'core-js/features/weak-map'; // Run `npm install --save web-animations-js`.
/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
import { Buffer } from 'buffer';

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/** IE10 and IE11 requires the following for the Reflect API. */
// import 'core-js/es6/reflect';

/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

(window as any).global = window; // some libs expect global
(window as any).process = { env: { DEBUG: undefined } };
(window as any).Buffer = Buffer;

if (!Element.prototype.matches) {
  Element.prototype.matches =
    (<any>Element.prototype).msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
